const ClickAndCollectIcon = ({ ...props }) => {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.308 0.440234L17.8786 4.81523C18.2217 5.40039 17.7914 6.125 17.0995 6.125H16.1995V9.25986L17.7143 9.71429L15.5571 10.4286L18 12.8714L16.8714 14L14.4286 11.5571L13.7143 13.7143L12 8L15.2995 8.98986V6.125H10.7995V13.084C10.7995 13.5898 10.3974 14 9.89954 14H2.69954C2.20173 14 1.79954 13.5898 1.79954 13.084V6.125H0.899541C0.207666 6.125 -0.222647 5.40039 0.120478 4.81523L2.6911 0.440234C2.85142 0.169531 3.14954 0 3.47298 0H14.5261C14.8495 0 15.1477 0.169531 15.308 0.440234ZM9.8949 13.1156C9.89674 13.1087 9.89954 13.0982 9.89954 13.084V9.625H2.69954V13.084C2.69954 13.1168 2.71642 13.1305 2.71642 13.1305L9.89392 13.125C9.89272 13.1238 9.89355 13.1207 9.8949 13.1156ZM2.69954 8.75H9.89954V6.125H2.69954V8.75ZM3.47298 0.875L0.902353 5.25H17.0995L14.5261 0.875H3.47298Z"
        fill="#464544"
      />
    </svg>
  )
}

export default ClickAndCollectIcon
